
function isCenterpagEnvironment() {
  const { origin } = window.location;
  return origin === process.env.VUE_APP_URL_CENTERPAG;
}

export default isCenterpagEnvironment;
